import React, { useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(form);

    try {
      const res = await fetch(
        "https://lifetimeinfotech.in/backend/contact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        },
      );

      const data = await res.json();

      console.log(data);

      alert(data.message);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="contact-section">
      <div className="p-folio__hero" data-aos="fade-down">
        <h1 className="p-folio__title"> Contact Us</h1>
        <p className="p-folio__subtitle">
          {" "}
          Have a project in mind or need help with your digital solution? Our
          team is here to assist you. Get in touch with us and let's build
          something amazing together.
        </p>

        {/* CATEGORY SELECTOR TABS */}
      </div>
      <div className="contact-sec">
        <div className="contact-container">
          <div className="contact-info" data-aos="fade-right">
            <h2>Get In Touch</h2>

            <p>
              We would love to hear from you. Whether you have a question about
              our services, pricing, or anything else, our team is ready to
              answer all your questions.
            </p>

            <div className="info-item">
              <i className="bi bi-geo-alt"></i>
              <div>
                <h4>Address</h4>
                <span>
                  Shop-17, UP GR Floor, Ranuja Complex, Nr- Riddhi Siddhi
                  School, Vallabhacharya Road, Ashvani Kumar, Surat-395008
                  Gujarat, India
                </span>
              </div>
            </div>

            <div className="info-item">
              <i className="bi bi-telephone"></i>
              <div>
                <h4>Phone</h4>
                <span>+91 99096 14445</span>
              </div>
            </div>

            <div className="info-item">
              <i className="bi bi-envelope"></i>
              <div>
                <h4>Email</h4>
                <span>lifetimeinfotech@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="contact-form" data-aos="fade-left">
            <h2>Send Us a Message</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={form.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <textarea
                  rows="5"
                  name="message"
                  placeholder="Write your message..."
                  value={form.message}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="contact-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="map-section">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3719.337554905448!2d72.85131287526185!3d21.21845908047887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDEzJzA2LjUiTiA3MsKwNTEnMTQuMCJF!5e0!3m2!1sen!2sin!4v1782717357041!5m2!1sen!2sin"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
